import { render, staticRenderFns } from "./ChatCreate.vue?vue&type=template&id=327e0b82&scoped=true"
import script from "./ChatCreate.vue?vue&type=script&lang=js"
export * from "./ChatCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327e0b82",
  null
  
)

export default component.exports